module.exports = __webpack_public_path__ + "img/der-lagermeister-logo.27317a67.png";